module.exports = __webpack_public_path__ + "static/media/change-direction-btn.95c8e32b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dublin-express/change-direction-btn.svg
// module id = 68
// module chunks = 0